import { Editor } from 'react-draft-wysiwyg';
import { makeStyles } from '@material-ui/core';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { NEW_BED_STATUS_LENGTH } from '../../comm/constant';

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '100% !important',
    height: '100% !important',
    display: 'block !important',
  },
  editor: {
    width: '100%',
    height: '20rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    '& .public-DraftStyleDefault-block': {
      margin: 'unset',
    },
    '& .DraftEditor-root': {
      height: '100%',
    },
  },
  link: {
    '& .rdw-link-modal-target-option': {
      display: 'none',
    },
  },
}));

const RichText = ({ value, onChange }) => {
  const classes = useStyles();

  const onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const text = contentState.getPlainText();

    // 检查字数是否超过上限
    if (text.length <= NEW_BED_STATUS_LENGTH.MEMO_REMARKS) {
      onChange(editorState);
    } else {
      onChange(value);
    }
  };

  return (
    <Editor
      editorState={value}
      wrapperClassName={classes.wrapper}
      editorClassName={classes.editor}
      onEditorStateChange={onEditorStateChange}
      toolbar={{
        options: [
          'colorPicker',
          'link',
          'embedded',
          'emoji',
          'image',
          'inline',
          'blockType',
          'fontSize',
          'fontFamily',
          'list',
          'textAlign',
          'history',
        ],
        textAlign: {
          options: ['left', 'center', 'right'],
        },
        link: {
          className: classes.link,
          defaultTargetOption: '_blank',
        },
      }}
    />
  );
};

export default RichText;
